import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { DIGO_SERVICES, browseServiceCardLinkProps } from '../digoServices';

import css from './SectionBrowseServicesDigo.module.css';

const ServiceCategoryCard = ({ service }) => {
  const linkProps = browseServiceCardLinkProps(service);
  return (
    <NamedLink
      name={linkProps.name}
      params={linkProps.params}
      to={linkProps.to}
      className={css.card}
    >
      <img src={service.photo} alt="" className={css.photo} loading="lazy" />
      <div className={css.text}>
        <div className={css.label}>{service.label}</div>
        <div className={css.sub}>{service.sub}</div>
      </div>
    </NamedLink>
  );
};

/**
 * Grid of clickable service categories for logged-in users.
 * Each card opens a new service request with the category title pre-filled.
 */
const SectionBrowseServicesDigo = () => {
  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>
          <FormattedMessage id="SectionBrowseServicesDigo.title" />
        </h2>
        <div className={css.grid}>
          {DIGO_SERVICES.map(service => (
            <ServiceCategoryCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionBrowseServicesDigo;
